import axios from "axios";
import cookieService from "../utils/CookieService";

const baseUrl = process.env.REACT_APP_API_URL;

const HandleApiHeader = () => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
  };
};

const HandleApiHeaderWithAuth = () => {
  const token = cookieService.getToken();
  return {
    headers: {
      "Content-Type": "application/json",
      "Authorization": token ? `Bearer ${token}` : "",
    },
  };
};

const login = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}/api/auth/login`, data, HandleApiHeader());
    return response;
  } catch (error) {
    console.error("AuthService login error:", error);
    throw error;
  }
};

const logout = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/api/auth/logout/${id}`, HandleApiHeader());
    return response;
  } catch (error) {
    console.error("AuthService logout error:", error);
    throw error;
  }
};

const getUserEntitlement = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/users/entitlements`, HandleApiHeaderWithAuth());
    return response;
  } catch (error) {
    console.error("AuthService getUserEntitlement error:", error);
    throw error;
  }
};

// Forgot password - request OTP (no auth)
const forgotPasswordRequestOtp = async (data) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/auth/forgot-password/otp`,
      data,
      HandleApiHeader()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to request OTP" };
  }
};

// Forgot password - reset using OTP (no auth)
const forgotPasswordReset = async (data) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/auth/forgot-password/reset`,
      data,
      HandleApiHeader()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to reset password" };
  }
};

export const authservices = {
  login,
  logout,
  getUserEntitlement,
  forgotPasswordRequestOtp,
  forgotPasswordReset,

  changePassword: async (passwordData) => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/auth/change-password`,
        passwordData,
        HandleApiHeaderWithAuth()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Failed to change password" };
    }
  },
};